// extracted by mini-css-extract-plugin
export default {"container":"MetricsSeparateCharts_container__1-MPK","plot":"MetricsSeparateCharts_plot__UvAw6","heading":"MetricsSeparateCharts_heading__1YCG1"};